import { createContext, useContext } from "react";
import type { AuthSettings } from "@/auth/authConfig";

export const AuthSettingsContext = createContext<AuthSettings | null>(null);

export function useAuthSettings(): AuthSettings {
  const settings = useContext(AuthSettingsContext);
  if (!settings) {
    throw new Error("useAuthSettings must be used inside an AuthSettingsProvider.");
  }
  return settings;
}
